<template>
	<div class="small-loader">
		<loader />
	</div>
</template>

<script>
export default {
	name: 'small-loader',
}
</script>

<style lang="scss">
.small-loader {
  position: relative;
  min-width: 100px;
  min-height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

  .loader {
    min-height: 25px;

    & > div {
      width: 25px;
      height: 25px;
    }
  }
}

.wrapper .btn__load-more .loader {
	display: block!important;
	min-height: unset !important;
    position: unset!important;
    top: unset!important;
    left: unset!important;
}
</style>
